const { useContext, useEffect } = require('react');
const { LibraryContext } = require('./context-provider');
import { Button, Dropdown, Flex, Typography } from 'antd';
const { Text } = Typography;

export default function GridListViewDropdown() {
   const { view, setView } = useContext(LibraryContext);

   const items = [
      {
         key: '1',
         label: (
            <Flex gap={16} align="center">
               <i className="fi fi-rr-apps" />
               <Text>Grid View</Text>
            </Flex>
         ),
         onClick: () => setView('grid'),
      },
      {
         key: '2',
         label: (
            <Flex gap={16} align="center">
               <i className="fi fi-rr-list" />
               <Text>List View</Text>
            </Flex>
         ),
         onClick: () => setView('list'),
      },
   ];

   return (
      <Dropdown trigger={['click']} menu={{ items, selectable: true, defaultSelectedKeys: ['1'] }}>
         <Button type="text">
            <Flex gap={0} align="center">
               <i className={`fi fi-rr-${view === 'grid' ? 'apps' : 'list'}`} />
               <i className="fi fi-rr-angle-small-down" />
            </Flex>
         </Button>
      </Dropdown>
   );
}
